import * as config from './config'
import React, {Component} from 'react'
import StepsIndicator from './StepsIndicator'
import Intro from './Intro'
import Confirmation from './Confirmation'
import Loading from './Loading'
import Erroring from './Erroring'
import store from 'store'
import extend from 'smart-extend'
import {getMarketingAttrs} from '../../landing/App'
import request from './request'
import Step1 from './steps/Step1'
import Step2 from './steps/Step2'
import Step3 from './steps/Step3'

STORAGE_KEY = 'purchaseForm.values'
DATA_SERVER = "https://#{process.env.HOST_NAME}/api"

class Form extends Component
	constructor: ()->
		super(arguments...)
		initialValues = if @props.agent then {} else getInitialValues(config.screenKeys)
		@updateForm = @setState.bind(@)
		@submit = @submit.bind(@)
		@state =
			current: 'intro'
			freetrial: window.location.search?.includes('freetrial=1')
			screenKeys: config.screenKeys
			values: initialValues
	
	render: ()->
		parentState = {@updateForm, @submit, formState:@state}
		<div>
			{unless @state.current is 'intro'
				<StepsIndicator {parentState...} />
			}

			<Intro _key="intro" {config.intro...} {parentState...} />
			
			<Step1 _key={config.steps[0].name} {config.steps[0]...} {parentState...} />
			<Step2 _key={config.steps[1].name} {config.steps[1]...} {parentState...} />
			<Step3 _key={config.steps[2].name} {config.steps[2]...} {parentState...} />
			
			<Confirmation _key="confirmation" {config.confirmation...} {parentState...} />

			<Loading _key="loading" {parentState...} />
			<Erroring _key="erroring" {parentState...} />
		</div>

	UNSAFE_componentWillUpdate: (props, state)->
		setInitialValues(extend.notKeys(['photo','qrcode']).clone(state.values))

	submit: ()->
		@setState(current:'loading')
		json = formatFinalData(@state.values)
		json.ref = @props.agent if @props.agent
		json.freetrial = @state.freetrial
		
		Promise.bind(@)
			# .delay(2000)
			# .then ()-> @setState(current:'erroring')
			.then ()-> request("#{DATA_SERVER}/requests", {json, retry:4, timeout:20000})
			.then @handleSuccess
			.catch @handleError
			# .finally ()-> @state.current = ''

	handleError: (err)->
		console.error(err)
		@setState(current:'erroring')

	handleSuccess: (result)->
		fbq?('track', 'AddToCart')
		if @props.onComplete
			await @props.onComplete()
		
		window.location.href = "/checkout/#{result._id}"


formatFinalData = (data)->
	data.name = data.name.titleize()
	data.position = data.position.titleize()

	return data

getInitialValues = (screenKeys)->
	{ref, source, meta} = getMarketingAttrs()
	value = store.get(STORAGE_KEY) or {}
	delete value.ref
	value.ref = ref if ref
	value.source = source if source
	value.meta = meta if meta
	store.set(STORAGE_KEY, value)
	return value

setInitialValues = (values)->
	store.set(STORAGE_KEY, values)


export default Form